import classNames from "classnames";
import React, { useState } from "react";
import { createUseStyles } from "react-jss";

const useStyles = createUseStyles((theme) => ({
	root: {},
	list: {
		margin: 0,
		padding: 0,
		listStyle: "none",
	},
	item: {
		marginBottom: "7px",
		fontSize: "12px",
		fontFamily: theme.fonts.medium,
		color: theme.palette.colors.darkSlateBlue,
		lineHeight: 1.42,
		position: "relative",
		"&:last-child": {
			marginBottom: 0,
		},
	},
	itemPrice: {
		display: "none",
		marginBottom: "7px",
		fontSize: "12px",
		fontFamily: theme.fonts.medium,
		color: theme.palette.colors.darkSlateBlue,
		lineHeight: 1.42,
		position: "relative",
		"&:last-child": {
			marginBottom: 0,
		},
	},
	item_dropdown: {
		color: theme.palette.colors.oneMoreGrey,
	},
	iconArrow: {
		paddingLeft: "5px",
		fontSize: "10px",
		fontWeight: "bold",
		color: theme.palette.colors.purplishBlue,
	},
	clickable: {
		cursor: "pointer",
	},
	colorPositiveBodyReview: {
		color: theme.palette.colors.positiveBodyReview,
		fontFamily: theme.fonts.bold,
	},
	[`@media (min-width: ${theme.media.md}) and (max-width: ${theme.media.lg})`]: {
		item: {
			marginBottom: "4px",
			"&:last-child": {
				marginBottom: 0,
			},
		},
	},
	[`@media (min-width: ${theme.media.sm}) and (max-width: ${theme.media.md})`]: {
		item: {
			marginBottom: "4px",
			"&:last-child": {
				marginBottom: 0,
			},
		},
	},
	[`@media (max-width: ${theme.media.sm})`]: {
		itemPrice: {
			display: "block",
		},
	},
}));

const DodyAccordionList = (props) => {
	const classes = useStyles();

	const [dodies, setDodies] = useState(() =>
		props.dody
			.filter((x) => x.state !== 0)
			.concat(props.additionalDody.filter(Boolean), props.additionalDescription?.filter(Boolean))
			.map((dody, i) => ({
				...dody,
				isOpened: dody.isOpened || false,
				key: i,
			}))
	);

	let actualDody = props.parentDody ? props.dody : dodies;

	const toggleDodyHandler = (dody) => {
		if (props.parentDody) {
			props.changeDodyTariff && props.changeDodyTariff(dody);
		} else {
			setDodies(
				dodies.map((additionalDody) =>
					additionalDody.key === dody.key
						? {
								...additionalDody,
								isOpened: !additionalDody.isOpened,
							}
						: additionalDody
				)
			);
		}
	};

	return (
		<div className={classes.root}>
			<ul className={classes.list}>
				{actualDody.map((item) => {
					return (
						<li className={item.className ? classes[item.className] : classes.item} key={item.key}>
							<span
								className={classNames("", {
									[classes.clickable]: item.short_description,
									[classes.colorPositiveBodyReview]: item.color,
								})}
								onClick={() => toggleDodyHandler(item)}
							>
								{item.name}
							</span>
							{item.short_description && (
								<>
									<span
										onClick={() => toggleDodyHandler(item)}
										className={classNames(
											item.isOpened ? "icon24 icon-arrow-1-up" : "icon24 icon-arrow-1-down",
											classes.iconArrow,
											classes.clickable
										)}
									/>
									{item.isOpened && (
										<>
											<br />
											<span
												className={classes.item_dropdown}
												dangerouslySetInnerHTML={{
													__html: item.short_description,
												}}
											/>
										</>
									)}
								</>
							)}
						</li>
					);
				})}
			</ul>
		</div>
	);
};

export default DodyAccordionList;
